import $ from 'jquery'
import AOS from 'aos'
require('bootstrap');
require('lightbox2');
require('smartmenus/src/jquery.smartmenus')

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$(document).ready(function (){
    AOS.init();

    // Gestion de l'accordéon dans la partie fiche page
    $('.informations-mobile .collapse').collapse();
    $(".informations-mobile #collapse-0").collapse('show');
    $(".informations-mobile button").on('click', function () {
        $(".informations-mobile .card-header").removeClass('active');
        $(this).parent('h2').parent('.card-header').toggleClass('active');
    });

    // Gestion du Slider
    if ($('.home-slider').length > 0) {
        let slider = tns({
            container: '.home-slider',
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayTimeout: 6000,
            navPosition: 'bottom',
            autoplayButtonOutput: false,
            controlsText: [
                '<i class="fas fa-chevron-left"></i>',
                '<i class="fas fa-chevron-right"></i>'
            ],
            nav: false
        });
    }

    // Gestion du formulaire de recherche
    let searchForm = $(".marillac-search-form");
    $("#menu-principal .search").on('click', function (event) {
        if (searchForm.hasClass('open')) {
            searchForm.removeClass('open');
        } else {
            searchForm.addClass('open');
        }
    });

    $(".marillac-search-form .close").on('click', function (event){
        if (searchForm.hasClass('open')) {
            searchForm.removeClass('open');
        } else {
            searchForm.addClass('open');
        }
    });

    // Gestion du menu
    $('#menu-menu-principal').smartmenus({
        subMenusSubOffsetX: -10,
        subMenusSubOffsetY: -9,
        bootstrapHighlightClasses: 'text-white bg-dark',
    });

    $(".filter-toggle").on('click', function (event) {
        let filter = $('.filters');
        filter.toggleClass('show');
    });
})